"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDatePicker = void 0;
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const react_1 = __importDefault(require("react"));
const lab_1 = require("@mui/lab");
const AdapterDateFns_1 = __importDefault(require("@mui/lab/AdapterDateFns"));
const calendar_mode_1 = require("../calendar-mode");
const pickers_1 = require("./pickers");
const renderCalendarDatePicker = (props) => {
    const { mode } = props;
    switch (mode) {
        case calendar_mode_1.CalendarModeEnum.DAY:
            return react_1.default.createElement(pickers_1.CalendarDayPicker, Object.assign({}, props));
        case calendar_mode_1.CalendarModeEnum.WEEK:
            return react_1.default.createElement(pickers_1.CalendarWeekPicker, Object.assign({}, props));
        case calendar_mode_1.CalendarModeEnum.MONTH:
            return react_1.default.createElement(pickers_1.CalendarMonthPicker, Object.assign({}, props));
        case calendar_mode_1.CalendarModeEnum.YEAR:
            return react_1.default.createElement(pickers_1.CalendarYearPicker, Object.assign({}, props));
        default:
            return react_1.default.createElement(pickers_1.CalendarDayPicker, Object.assign({}, props));
    }
};
/**
 * Calendar date picker based on mode
 * @param props - ICalendarSelectProps
 * @returns CalendarDatePicker
 */
exports.CalendarDatePicker = (props) => {
    return react_1.default.createElement(lab_1.LocalizationProvider, { dateAdapter: AdapterDateFns_1.default }, renderCalendarDatePicker(props));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FsZW5kYXJEYXRlUGlja2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NhbGVuZGFyL2RhdGUtcGlja2VyL0NhbGVuZGFyRGF0ZVBpY2tlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7OztHQU1HO0FBQ0gsa0RBQTBCO0FBQzFCLGtDQUFnRDtBQUNoRCw2RUFBcUQ7QUFFckQsb0RBQW9EO0FBRXBELHVDQUEyRztBQUUzRyxNQUFNLHdCQUF3QixHQUFHLENBQUMsS0FBMkIsRUFBRSxFQUFFO0lBQy9ELE1BQU0sRUFBRSxJQUFJLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDdkIsUUFBUSxJQUFJLEVBQUU7UUFDWixLQUFLLGdDQUFnQixDQUFDLEdBQUc7WUFDdkIsT0FBTyw4QkFBQywyQkFBaUIsb0JBQUssS0FBSyxFQUFJLENBQUM7UUFDMUMsS0FBSyxnQ0FBZ0IsQ0FBQyxJQUFJO1lBQ3hCLE9BQU8sOEJBQUMsNEJBQWtCLG9CQUFLLEtBQUssRUFBSSxDQUFDO1FBQzNDLEtBQUssZ0NBQWdCLENBQUMsS0FBSztZQUN6QixPQUFPLDhCQUFDLDZCQUFtQixvQkFBSyxLQUFLLEVBQUksQ0FBQztRQUM1QyxLQUFLLGdDQUFnQixDQUFDLElBQUk7WUFDeEIsT0FBTyw4QkFBQyw0QkFBa0Isb0JBQUssS0FBSyxFQUFJLENBQUM7UUFDM0M7WUFDRSxPQUFPLDhCQUFDLDJCQUFpQixvQkFBSyxLQUFLLEVBQUksQ0FBQztLQUMzQztBQUNILENBQUMsQ0FBQztBQUVGOzs7O0dBSUc7QUFDVSxRQUFBLGtCQUFrQixHQUFHLENBQUMsS0FBMkIsRUFBRSxFQUFFO0lBQ2hFLE9BQU8sOEJBQUMsMEJBQW9CLElBQUMsV0FBVyxFQUFFLHdCQUFjLElBQUcsd0JBQXdCLENBQUMsS0FBSyxDQUFDLENBQXdCLENBQUM7QUFDckgsQ0FBQyxDQUFDIn0=